export default function () {
  if (false || !!document.documentMode) {
    // IE
    document.write('<script src="./js/ie-script.js"></script>')
  }
};
